const AbstractRepository = require('@/lib/Repositories/AbstractRepository');
const DataStoreNames = require('@/lib/DataStores/DataStoreNames');
const KitchenZone = require('@/lib/Kitchen/KitchenZone');
const { createModelBasicHydrator } = require('@/lib/Hydration/basicHydrator');

class KitchenZoneRepository extends AbstractRepository {
    /**
     * @param {DataStore} dataStore
     * @param {Hydrator} hydrator
     * @param {SyncStateManager} syncStateManager
     * @param {ApiClient} apiClient
     */
    constructor(
        dataStore,
        hydrator,
        syncStateManager,
        apiClient,
    ) {
        super(dataStore, hydrator, syncStateManager);

        this.apiClient = apiClient;
    }

    getEntityClass() {
        return KitchenZone;
    }

    getEntityName() {
        return 'Kitchen Zone';
    }

    getTableName() {
        return DataStoreNames.KITCHEN_ZONES;
    }

    loadFromApi(branchID = null) {
        return this.apiClient
            .request(
                'GET',
                'kitchenzones',
                {
                    branchID, // Send the requested branchID to the API so it is used instead of any default.
                }
            )
            .then(({ data }) => {
                return this.hydrateModelsFromApi(data);
            });
    }

    /**
     * @param {number} branchID
     *
     * @returns {Promise<KitchenZone[]>}
     */
    findForBranch(branchID) {
        return this.dataStore
            .getStore(this.getTableName())
            .where({ branchID })
            .toArray()
            .then(createModelBasicHydrator(this.getEntityClass()));
    }
}

module.exports = KitchenZoneRepository;
